import { CellValueChangedEvent } from "ag-grid-community";
import { useCallback } from "react";
import { showWarning } from "src/utils/toast/toastUtil";
import {
	KSK1120_R01DetailDto,
	KSK1120_R01InspectionValueField,
	KSK1120_R01_VALUE_FIELDS,
} from "../Dto_KSK1120_R01";
import {
	normalizeKSK1120_R01InspectionValue,
	normalizeKSK1120_R01ValueType,
	validateKSK1120_R01InspectionValue,
} from "../Util_KSK1120_R01";

interface UseKSK1120_R01DetailCellChangeProps {
	detailList: KSK1120_R01DetailDto[];
	updateKSK1120_R01DetailList: (valueIndex: number, data: KSK1120_R01DetailDto) => void;
}

export const useKSK1120_R01DetailCellChange = ({
	detailList,
	updateKSK1120_R01DetailList,
}: UseKSK1120_R01DetailCellChangeProps) => {
	const handleCellValueChanged = useCallback((event: CellValueChangedEvent<KSK1120_R01DetailDto>) => {
		if (!event.data || event.node.rowPinned === "bottom") return;

		const field = event.colDef.field;
		if (field === "remark") {
			const remark = String(event.newValue ?? "").trim();
			if (remark.length > 1000) {
				showWarning("비고는 1000자 이내로 입력해 주세요.");
				const previousValue = String(event.oldValue ?? "");
				event.node.setDataValue(field, previousValue);
				updateKSK1120_R01DetailList(event.data.valueIndex, {
					...event.data,
					remark: previousValue,
				});
				return;
			}
			updateKSK1120_R01DetailList(event.data.valueIndex, {
				...event.data,
				remark,
			});
			return;
		}
		if (!KSK1120_R01_VALUE_FIELDS.includes(field as KSK1120_R01InspectionValueField)) return;
		const valueField = field as KSK1120_R01InspectionValueField;

		const normalizedValue = normalizeKSK1120_R01InspectionValue(
			event.data.valueType,
			event.newValue,
		);
		const updatedDetail = { ...event.data, [valueField]: normalizedValue };
		if (!validateKSK1120_R01InspectionValue(updatedDetail)) {
			showWarning(
				normalizeKSK1120_R01ValueType(event.data.valueType) === "NUMERIC"
					? "숫자 형식으로 입력해 주세요."
					: "검사 결과 형식을 확인해 주세요.",
			);
			const previousValue = String(event.oldValue ?? "");
			event.node.setDataValue(valueField, previousValue);
			updateKSK1120_R01DetailList(event.data.valueIndex, {
				...event.data,
				[valueField]: previousValue,
			});
			return;
		}

		updateKSK1120_R01DetailList(event.data.valueIndex, updatedDetail);
	}, [updateKSK1120_R01DetailList]);

	const handlePassFailChange = useCallback((
		valueIndex: number,
		valueField: KSK1120_R01InspectionValueField,
		value: "Y" | "N" | "",
	) => {
		const detail = detailList.find((item) => item.valueIndex === valueIndex);
		if (!detail || normalizeKSK1120_R01ValueType(detail.valueType) !== "PASS_FAIL") return;
		updateKSK1120_R01DetailList(valueIndex, {
			...detail,
			[valueField]: value,
		});
	}, [detailList, updateKSK1120_R01DetailList]);

	return { handleCellValueChanged, handlePassFailChange };
};


